import { restClient } from '@/Core'

/** Що генерація бере з договору: номер і дату. */
export interface LastContractTerms {
    number: string | null
    /** `YYYY-MM-DD` */
    date: string | null
}

type CollectionResponse = { items?: unknown[]; 'hydra:member'?: unknown[] } | unknown[] | null

/**
 * Останній договір власника з обраною юрособою-експедитором (`SPEC-012` P-16;
 * легасі `GetContractByLegalTask.js:3-20`): невидалений, новіший за датою
 * створення — перший. Немає — `null`, і поля шухляди не змінюються.
 *
 * Номер — поле `number` договору (у легасі ним був `title`; тут `title` —
 * «№ … від …», складена назва).
 */
export const GetLastContractTask = async (
    contractsRestUrl: string,
    ownerField: string,
    ownerUuid: string,
    legalEntityUuid: string
): Promise<LastContractTerms | null> => {
    const filters = JSON.stringify({
        and: [
            { field: `${ownerField}.uuid`, op: '=', value: ownerUuid },
            { field: 'forwarder.uuid', op: '=', value: legalEntityUuid },
        ],
    })

    const raw = await restClient.get(
        `${contractsRestUrl}?limit=1&sort[createdAt]=DESC&filters=${encodeURIComponent(filters)}`,
        undefined,
        // Договір могли щойно додати на сусідній вкладці
        { forceRefresh: true }
    )
    const data = raw as unknown as CollectionResponse
    const items = Array.isArray(data) ? data : (data?.items ?? data?.['hydra:member'] ?? [])
    const first = Array.isArray(items) ? items[0] : undefined

    if (first === null || typeof first !== 'object') return null

    const record = first as Record<string, unknown>
    const number = typeof record['number'] === 'string' && record['number'] !== '' ? record['number'] : null
    const date = typeof record['date'] === 'string' && record['date'].length >= 10 ? record['date'].slice(0, 10) : null

    return { number, date }
}
